var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('button',{staticClass:"button is-info",class:_vm.buttonClass,on:{"click":_vm.toggleOutliers}},[_c('span',[_vm._v("Toggle outliers")]),_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fal",class:_vm.buttonIcon})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }